<template>
  <div class="page-content">
    <a-card style="width: 100%" size="small" v-for="item in followList" :key="item" class="mt-10">
      <Cell label="跟进号码" :value="item.phone" />
      <Cell label="通话状态">
        {{ selectDictLabel(callStatusList, item.callStatus) }}
      </Cell>
      <Cell label="跟进人" :value="item.createUser" />
      <Cell label="跟进时间" :value="item.createTime" />
      <Cell label="备注" :value="item.remark" />
    </a-card>

    <div class="page-content-footer" style="position: fixed; bottom: 0; left: 0; right: 0; padding: 10px 16px; background-color: #f0f2f5; border-top: 1px solid #e8e8e8; z-index: 1000;">
      <a-button type="primary" style="width: 100%;" @click="addRecord">添加跟进记录</a-button>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { getFollowList } from '@/api/phoneBank'
import Cell from '@/component/cell.vue'
import { useRoute, useRouter } from 'vue-router';
import { useDict } from '@/utils/dict';
import { selectDictLabel } from '@/utils/dict'

const route = useRoute()
const router = useRouter()
const { call_status: callStatusList } = useDict('call_status')
const phoneBankId = ref()
const followList = ref([])
const show = ref(false)

onMounted(() => {
  phoneBankId.value = route.query.phoneBankId
  loadFollowList()
})

function loadFollowList() {
  getFollowList(phoneBankId.value).then(response => {
    followList.value = response
  })
}

function initRecord() {
  show.value = true
}

function addRecord() {
  router.push({
    path: '/phoneBankAddRecord',
    query: {
      phoneBankId: phoneBankId.value
    }
  })
}
</script>

<style scoped>
.page-content {
  padding: 0px 16px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f0f2f5;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.mt-10 {
  margin-top: 10px;
}

.page-content-footer {
  padding: 10px;
}
</style>
